import { ChevronDown, ChevronUp } from '../../icons'
import { Button } from '../button/button'

export interface DetailPanelNavigationProps {
  onPrevious?: () => void
  onNext?: () => void
  previousLabel: string
  nextLabel: string
}

/** Navigate the displayed list without closing its detail panel. */
export function DetailPanelNavigation({
  onPrevious,
  onNext,
  previousLabel,
  nextLabel,
}: DetailPanelNavigationProps) {
  return (
    <div className='flex shrink-0 items-center'>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        disabled={!onPrevious}
        onClick={onPrevious}
        aria-label={previousLabel}
        title={previousLabel}
      >
        <ChevronUp aria-hidden />
      </Button>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        disabled={!onNext}
        onClick={onNext}
        aria-label={nextLabel}
        title={nextLabel}
      >
        <ChevronDown aria-hidden />
      </Button>
    </div>
  )
}
